import React from "react";
import { Create, translate } from "react-admin";
import AnnounceForm from "./AnnounceForm";

const AnnounceTitle = ({ translate }) => {
  return <span>{`สร้าง${translate("announce.announce")}`}</span>;
};

const Title = translate(AnnounceTitle);

export const AnnounceCreate = props => (
  <Create title={<Title />} {...props}>
    <AnnounceForm />
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/announce/AnnounceCreate.js